export const exclusionCategory = {
  EXTRAORDINARY: 'extraordinary',
  EXCLUSIONS: 'exclusions'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/ExclusionCategoryEnum.js